import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslocoModule } from '@jsverse/transloco';
import { TranslocoDatePipe } from '@jsverse/transloco-locale';
import saveAs from 'file-saver';
import { AssetmanagementService } from 'guideline/feature-attachment';
import { InsightsService } from 'libs/shared/domain/src/lib/infrastructure/insights.service';
import { TrackingEvent } from 'libs/shared/domain/src/lib/infrastructure/tracking-events';
import { IconDirective } from 'libs/shared/ui-common/src/lib/components/icon/icon.directive';
import { TooltipDirective } from 'libs/shared/ui-common/src/lib/components/tooltip/tooltip.directive';
import { AddZToUTCPipe } from 'libs/shared/util-common/src/lib/pipes/add-z-to-utc.pipe';

import { NodeDetailPopoverAttachment } from '@treetop/shared/model';

import { NetworkStatusService } from '../../../../util-common/src/lib/services/network-status.service';

@Component({
  selector: 'tt-node-detail-popover-attachments',
  standalone: true,
  imports: [TranslocoModule, MatIconModule, IconDirective, MatTooltipModule, TooltipDirective, TranslocoDatePipe, AddZToUTCPipe],
  templateUrl: './node-detail-popover-attachments.component.html',
  styleUrl: './node-detail-popover-attachments.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NodeDetailPopoverAttachmentsComponent {
  protected isOnline = inject(NetworkStatusService).isOnline;

  @Input() public attachments: NodeDetailPopoverAttachment[];
  @Input() public localAttachments: NodeDetailPopoverAttachment[] = [];
  @Input() public deletedOriginalAttachmentIds: string[];

  protected get filteredAttachments(): NodeDetailPopoverAttachment[] {
    return this.attachments.filter((attachment) => !(this.deletedOriginalAttachmentIds ?? []).includes(attachment.id));
  }

  private assetManagementService = inject(AssetmanagementService);
  private insightsService = inject(InsightsService);

  protected handleRowClick(attachment: NodeDetailPopoverAttachment) {
    if (!this.isOnline()) {
      return;
    }

    this.assetManagementService.downloadAttachment(attachment.id).subscribe((response) => {
      this.insightsService.trackEvent(TrackingEvent.ATTACHMENT_DOWNLOADED, {
        attachmentTitle: attachment.title,
      });

      saveAs(response.body, attachment.title, { autoBom: false });
    });
  }
}
